import AddressInput from './AddressInput';
import { useWatch, useFormContext } from 'react-hook-form';
import { useState, useEffect, useContext } from 'react';
import { Box } from '@cof/plastic-components';
import { withText } from '../../../text/textStore';
import { NarrativeTextHookForm } from '../../../components/NarrativeText/NarrativeText';
import PropTypes from 'prop-types';
import { FORM_SECTIONS } from './FormIDs';
import { FormUtilsContext } from '../QuickCheck';
import { useFormData } from '../../../components/FormDataContext/FormDataContext';

const AddressForm = ({ Text }: any) => {
    const [selectedCurrentAddress, setSelectedCurrentAddress] = useState(null);
    const [showPrevious, setShowPrevious] = useState(false);
    const yearsAtCurrent = useWatch({ name: FORM_SECTIONS.Address.Current.YearsAtAddress });
    const { getValues } = useFormContext();
    // @ts-expect-error TS2339: Property 'setShowManualForm' does not exist on type 'null'.
    const { setShowManualForm } = useContext(FormUtilsContext);
    const { isEdit } = useFormData();

    useEffect(() => {
        if (!isEdit) return;

        const previousAddressTown = getValues(FORM_SECTIONS.Address.Previous.Town);
        const yearsUnderTwo = yearsAtCurrent !== undefined && parseInt(yearsAtCurrent, 10) < 2;

        if (yearsUnderTwo && previousAddressTown) {
            setShowManualForm(() => ({ current: true, previous: true }));
            setShowPrevious(true);
        }
    }, [isEdit, yearsAtCurrent, getValues, setShowManualForm]);

    return (
        <Box>
            <NarrativeTextHookForm data-qm-allow>
                <Text path="Heading" />
            </NarrativeTextHookForm>
            <AddressInput
                isCurrent={true}
                setSelectedCurrentAddress={setSelectedCurrentAddress}
                setShowPrevious={setShowPrevious}
            />

            {yearsAtCurrent !== undefined && parseInt(yearsAtCurrent, 10) < 2 && showPrevious && (
                <AddressInput isCurrent={false} selectedCurrentAddress={selectedCurrentAddress} />
            )}
        </Box>
    );
};

AddressForm.propTypes = {
    Text: PropTypes.func.isRequired
};

export default withText('Address')(AddressForm);
